module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-news",
    attrs: {
      "id": "pc-news"
    }
  }, [_c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "header-wrap-id"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "nav"
  }, [_c('ul', [_c('img', {
    staticClass: "menu-logo",
    attrs: {
      "src": "https://www.xfz.cn/explore/xfz2019/static/img/logo.128ba78.png"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-guest"
    }
  }, [_vm._v("邀请嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "section live"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("直播支持平台")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, _vm._l((_vm.liveLinks), function(item) {
    return _c('a', {
      staticClass: "live-item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])
  }))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section live"
  }, [_c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("大会直播")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, _vm._l((_vm.liveData[0]), function(item) {
    return _c('div', {
      staticClass: "live-item"
    }, [_c('div', {
      staticClass: "live-name"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "live-links"
    }, [(item.links.length == 1) ? [_c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[0].name))])])] : _vm._e(), _vm._v(" "), (item.links.length == 2) ? [_c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[0].name))])]), _vm._v(" "), _c('div', {
      staticClass: "link-divider"
    }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[1].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[1].name))])])] : _vm._e()], 2)])
  }))])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section course"
  }, [_c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("投资人眼中的消费升级")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, _vm._l((_vm.investorUpData), function(item) {
    return _c('div', {
      staticClass: "course-item"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-logo"
    }, [_c('img', {
      staticClass: "main",
      attrs: {
        "src": item.img,
        "alt": "资本寒冬，创业公司如何快速获取融资"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tags"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_c('div', {
      staticClass: "course-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info-author"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.position ? '/' : '') + " " + _vm._s(item.position))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("新品牌、新零售、新场景")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, _vm._l((_vm.useUpData), function(item) {
    return _c('div', {
      staticClass: "course-item"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-logo"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "资本寒冬，创业公司如何快速获取融资"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tags"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_c('div', {
      staticClass: "course-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info-author"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.position ? '/' : '') + " " + _vm._s(item.position))])])])])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pc-news-list"
  }, [_c('div', {
    staticClass: "news-list-wrap"
  }, [_c('div', {
    staticClass: "title-area"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("大会相关新闻")]), _vm._v(" "), _c('div', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.refreshContent()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-refresh.png"),
      "alt": ""
    }
  }), _vm._v(" 刷新\n                ")])]), _vm._v(" "), _vm._l((_vm.newsData), function(item) {
    return [_c('pc-news-item', {
      attrs: {
        "news": item
      }
    })]
  }), _vm._v(" "), (_vm.newsData.length == 0) ? [_c('div', {
    staticStyle: {
      "width": "200px",
      "text-align": "center",
      "margin": "20px auto",
      "font-size": "22px"
    }
  }, [_vm._v("暂无新闻")])] : _vm._e()], 2)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("官方直播平台")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, [_c('a', {
    staticClass: "live-item",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "href": "https://m.yiketalks.com/html/liveEnrollDetail2.html?id=1241",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1573721713130/一刻-fintech.partner"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "live-item",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "href": "https://live.photoplus.cn/live/54564923",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1573726183073/谱时-fintech.partner"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a47c3fda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PcNews.vue
// module id = 156
// module chunks = 1